import IRSFooter from "./IRSFooter"
import Footer from "./Footer"
import FooterTop from "./FooterTop"
import FooterTopGroup from "./FooterTopGroup"
import FooterTopGroupItem from "./FooterTopGroupItem"

export default IRSFooter
export { Footer, FooterTop, FooterTopGroup, FooterTopGroupItem }
